const FamilyConfig = {
  collection: "families",
  fields: ["id", "brand.id", "family", "trademarked"],

  filter: "filter[status][_eq]=active",

  adapter: class Family {
    constructor(family) {
      this.id = family.id;
      this.family = family.family;
      this.trademarked = family.trademarked;
    }
  }
};

export default FamilyConfig;
